import React from 'react';
import Svg from 'rp-react-svg-icon';

function ShortlistDescription() {
    return (
        <p className="shortlistDescription">
            Create your own shortlist of lots from any Upcoming Sale by simply clicking
            the star icon&nbsp;
            <Svg
                iconName="starHollow"
                size="Medium"
                className="shortlistDescription__icon"
            />
            &nbsp;found on each lot.<br />

            Selected lots will then have a red star&nbsp;
            <Svg
                iconName="starFilled"
                size="Medium"
                className="shortlistDescription__icon shortlistDescription__icon_star"
            />
            &nbsp;and are automatically added to your shortlist on this page.<br />

            You can sort your shortlisted horses by all the column headers in the table.<br />

            To remove horses from your shortlist select the tick icon and
            click on the red bin icon&nbsp;
            <span className="ui-btn ui-btn_primary shortlistDescription__button">
                <Svg
                    iconName="bin"
                    size="Small"
                    className="shortlistDescription__icon shortlistDescription__icon_bin"
                />
            </span>
            <br />

            Shortlisted lots are stored for up to two weeks after the completion of a sale.
        </p>
    );
}

export default ShortlistDescription;



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/ShortlistDescription.js